import CashRegisters from './CashRegisters'
import CashRegistersHandler from './CashRegistersHandler'
import tableColumns from './tableColumns'
import { listHolidays, getHoliday, updateFreeDay } from './gql'

const sectionSettings = t => ([{
	link: 'einstellungen',
	columns: tableColumns(t),
	listQuery: listHolidays,
	itemQuery: getHoliday,
	handler: CashRegistersHandler,
	subsections: [{
		link: '',
		component: CashRegisters,
		updateMutation: updateFreeDay,
		fields: ['cashRegisterId']
	}]
}])

export default sectionSettings
